/*! Split.js - v1.3.5 */
! function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.Split = t()
}(this, function() {
    "use strict";
    var e = window,
        t = e.document,
        n = "addEventListener",
        i = "removeEventListener",
        r = "getBoundingClientRect",
        s = function() {
            return !1
        },
        o = e.attachEvent && !e[n],
        a = ["", "-webkit-", "-moz-", "-o-"].filter(function(e) {
            var n = t.createElement("div");
            return n.style.cssText = "width:" + e + "calc(9px)", !!n.style.length
        }).shift() + "calc",
        l = function(e) {
            return "string" == typeof e || e instanceof String ? t.querySelector(e) : e
        };
    return function(u, c) {
        function z(e, t, n) {
            var i = A(y, t, n);
            Object.keys(i).forEach(function(t) {
                return e.style[t] = i[t]
            })
        }

        function h(e, t) {
            var n = B(y, t);
            Object.keys(n).forEach(function(t) {
                return e.style[t] = n[t]
            })
        }

        function f(e) {
            var t = E[this.a],
                n = E[this.b],
                i = t.size + n.size;
            t.size = e / this.size * i, n.size = i - e / this.size * i, z(t.element, t.size, this.aGutterSize), z(n.element, n.size, this.bGutterSize)
        }

        function m(e) {
            var t;
            this.dragging && ((t = "touches" in e ? e.touches[0][b] - this.start : e[b] - this.start) <= E[this.a].minSize + M + this.aGutterSize ? t = E[this.a].minSize + this.aGutterSize : t >= this.size - (E[this.b].minSize + M + this.bGutterSize) && (t = this.size - (E[this.b].minSize + this.bGutterSize)), f.call(this, t), c.onDrag && c.onDrag())
        }

        function g() {
            var e = E[this.a].element,
                t = E[this.b].element;
            this.size = e[r]()[y] + t[r]()[y] + this.aGutterSize + this.bGutterSize, this.start = e[r]()[G]
        }

        function d() {
            var t = this,
                n = E[t.a].element,
                r = E[t.b].element;
            t.dragging && c.onDragEnd && c.onDragEnd(), t.dragging = !1, e[i]("mouseup", t.stop), e[i]("touchend", t.stop), e[i]("touchcancel", t.stop), t.parent[i]("mousemove", t.move), t.parent[i]("touchmove", t.move), delete t.stop, delete t.move, n[i]("selectstart", s), n[i]("dragstart", s), r[i]("selectstart", s), r[i]("dragstart", s), n.style.userSelect = "", n.style.webkitUserSelect = "", n.style.MozUserSelect = "", n.style.pointerEvents = "", r.style.userSelect = "", r.style.webkitUserSelect = "", r.style.MozUserSelect = "", r.style.pointerEvents = "", t.gutter.style.cursor = "", t.parent.style.cursor = ""
        }

        function S(t) {
            var i = this,
                r = E[i.a].element,
                o = E[i.b].element;
            !i.dragging && c.onDragStart && c.onDragStart(), t.preventDefault(), i.dragging = !0, i.move = m.bind(i), i.stop = d.bind(i), e[n]("mouseup", i.stop), e[n]("touchend", i.stop), e[n]("touchcancel", i.stop), i.parent[n]("mousemove", i.move), i.parent[n]("touchmove", i.move), r[n]("selectstart", s), r[n]("dragstart", s), o[n]("selectstart", s), o[n]("dragstart", s), r.style.userSelect = "none", r.style.webkitUserSelect = "none", r.style.MozUserSelect = "none", r.style.pointerEvents = "none", o.style.userSelect = "none", o.style.webkitUserSelect = "none", o.style.MozUserSelect = "none", o.style.pointerEvents = "none", i.gutter.style.cursor = j, i.parent.style.cursor = j, g.call(i)
        }

        function v(e) {
            e.forEach(function(t, n) {
                if (n > 0) {
                    var i = F[n - 1],
                        r = E[i.a],
                        s = E[i.b];
                    r.size = e[n - 1], s.size = t, z(r.element, r.size, i.aGutterSize), z(s.element, s.size, i.bGutterSize)
                }
            })
        }

        function p() {
            F.forEach(function(e) {
                e.parent.removeChild(e.gutter), E[e.a].element.style[y] = "", E[e.b].element.style[y] = ""
            })
        }
        void 0 === c && (c = {});
        var y, b, G, E, w = l(u[0]).parentNode,
            D = e.getComputedStyle(w).flexDirection,
            U = c.sizes || u.map(function() {
                return 100 / u.length
            }),
            k = void 0 !== c.minSize ? c.minSize : 100,
            x = Array.isArray(k) ? k : u.map(function() {
                return k
            }),
            L = void 0 !== c.gutterSize ? c.gutterSize : 10,
            M = void 0 !== c.snapOffset ? c.snapOffset : 30,
            O = c.direction || "horizontal",
            j = c.cursor || ("horizontal" === O ? "ew-resize" : "ns-resize"),
            C = c.gutter || function(e, n) {
                var i = t.createElement("div");
                return i.className = "gutter gutter-" + n, i
            },
            A = c.elementStyle || function(e, t, n) {
                var i = {};
                return "string" == typeof t || t instanceof String ? i[e] = t : i[e] = o ? t + "%" : a + "(" + t + "% - " + n + "px)", i
            },
            B = c.gutterStyle || function(e, t) {
                return n = {}, n[e] = t + "px", n;
                var n
            };
        "horizontal" === O ? (y = "width", "clientWidth", b = "clientX", G = "left", "paddingLeft") : "vertical" === O && (y = "height", "clientHeight", b = "clientY", G = "top", "paddingTop");
        var F = [];
        return E = u.map(function(e, t) {
            var i, s = {
                element: l(e),
                size: U[t],
                minSize: x[t]
            };
            if (t > 0 && (i = {
                    a: t - 1,
                    b: t,
                    dragging: !1,
                    isFirst: 1 === t,
                    isLast: t === u.length - 1,
                    direction: O,
                    parent: w
                }, i.aGutterSize = L, i.bGutterSize = L, i.isFirst && (i.aGutterSize = L / 2), i.isLast && (i.bGutterSize = L / 2), "row-reverse" === D || "column-reverse" === D)) {
                var a = i.a;
                i.a = i.b, i.b = a
            }
            if (!o && t > 0) {
                var c = C(t, O);
                h(c, L), c[n]("mousedown", S.bind(i)), c[n]("touchstart", S.bind(i)), w.insertBefore(c, s.element), i.gutter = c
            }
            0 === t || t === u.length - 1 ? z(s.element, s.size, L / 2) : z(s.element, s.size, L);
            var f = s.element[r]()[y];
            return f < s.minSize && (s.minSize = f), t > 0 && F.push(i), s
        }), o ? {
            setSizes: v,
            destroy: p
        } : {
            setSizes: v,
            getSizes: function() {
                return E.map(function(e) {
                    return e.size
                })
            },
            collapse: function(e) {
                if (e === F.length) {
                    var t = F[e - 1];
                    g.call(t), o || f.call(t, t.size - t.bGutterSize)
                } else {
                    var n = F[e];
                    g.call(n), o || f.call(n, n.aGutterSize)
                }
            },
            destroy: p
        }
    }
});